import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../styles/reactDatePicker.css';

import { ptBR } from 'date-fns/locale';

registerLocale('pt-BR', ptBR);
